import { useEffect, useState } from 'react'
import { Session } from '@supabase/supabase-js'
import { supabase } from '@/lib/supabase/client'

export function useSession() {
  const [session, setSession] = useState<Session | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Recupera a sessão do localStorage
    let savedSession = null
    try {
      const saved = localStorage.getItem('ephemeral-cards-session')
      if (saved) {
        savedSession = JSON.parse(saved)
      }
    } catch (error) {
      console.error('Erro ao recuperar sessão:', error)
    }

    // Verifica a sessão atual e sincroniza
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        setSession(session)
        // Salva a sessão atualizada
        localStorage.setItem('ephemeral-cards-session', JSON.stringify(session))
      } else if (savedSession) {
        // Se não há sessão atual mas temos uma salva, tenta restaurar
        supabase.auth.setSession({
          access_token: savedSession.access_token,
          refresh_token: savedSession.refresh_token,
        }).then(({ data: { session } }) => {
          if (session) {
            setSession(session)
            localStorage.setItem('ephemeral-cards-session', JSON.stringify(session))
          } else {
            // Se não conseguiu restaurar, limpa o storage
            localStorage.removeItem('ephemeral-cards-session')
          }
        })
      }
      setLoading(false)
    })

    // Escuta mudanças na autenticação
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (session) {
        localStorage.setItem('ephemeral-cards-session', JSON.stringify(session))
      } else {
        localStorage.removeItem('ephemeral-cards-session')
      }
    })

    return () => subscription.unsubscribe()
  }, [])

  return { session, loading }
} 